import _ from 'lodash';
import createLocationModel, { prop } from './lib/create_location_model';
import InteractionType from 'models/interaction_type';
import PerformanceDateRange from 'models/performance_date_range';

const GuidePerformanceView = createLocationModel({
  modelName: 'GuidePerformanceView',
  properties: {
    dateRange: prop()
      .oneOf(...Object.values(PerformanceDateRange))
      .default(PerformanceDateRange.LAST_1_DAY),
    guideCollectionId: prop(String),
    interactionType: prop().oneOf(
      '',
      InteractionType.CHAT,
      InteractionType.EMAIL,
      InteractionType.PHONE_CALL,
      InteractionType.SMS
    ),
    sort: prop({
      key: prop(String).isRequired,
      direction: prop().oneOf('asc', 'desc'),
    }),
    pageNumber: prop(Number),
  },

  deriveNew(newQuery) {
    return GuidePerformanceView.create(_.assign({}, this, newQuery));
  },

  statics: {
    breadcrumb: 'Journeys',
  },
});

export default GuidePerformanceView;
